import src from "IMAGE";
export default { src, width: 119, height: 26, blurWidth: 0, blurHeight: 0};
